<script setup>
    defineProps({
        title: String,
        text: String,
    })
</script>

<template>
    <div class="section-page-banner-text mx-auto w-full max-w-full overflow-hidden">
        <div class="container mx-auto max-w-2xl text-center text-white">
            <h1 class="text-3xl">{{ title }}</h1>
            <div class="section-text text-lg" v-html="text"></div>
        </div>
    </div>
</template>

<style scoped>
    .section-page-banner-text {
        background: linear-gradient(270deg, #0a0430 -46.62%, #1a30ac 63.98%, #254eff 110.96%);
        padding-block: 3.75rem;
        margin-bottom: 2.5rem;
    }

    @screen md {
        .section-page-banner-text {
            padding-block: 5.75rem;
            margin-bottom: 4.5rem;
        }
    }
</style>
